module.exports = __webpack_public_path__ + "img/OpenShift.3942fbc.svg";